export const SEAT_TYPES = {
  AVAILABLE: "Available",
  UNAVAILABLE: "Unavailable",
  FEMALE: "Female",
};

// clear seats constant
export const CLEAR_SEATS = "CLEAR_SEATS";

// CITIES constant
export const FETCH_CITIES_REQUEST = "FETCH_CITIES_REQUEST";
export const FETCH_CITIES_SUCCESS = "FETCH_CITIES_SUCCESS";
export const FETCH_CITIES_FAILURE = "FETCH_CITIES_FAILURE";

// Passenger Details form
export const SUBMIT_PASSENGER_DETAILS = "SUBMIT_PASSENGER_DETAILS";
